import AuthContext from 'context/AuthProvider';
import { useContext } from 'react';

const useAuth: any = () => {
  return useContext(AuthContext);
};

export default useAuth;
